export default {
  submit: {
    id: 'bo_seller_customer_reviews_filters_apply_filters',
    defaultMessage: 'Apply filters',
  },
  filter: {
    id: 'bo_seller_customer_reviews_filters_filter',
    defaultMessage: 'Filter',
  },
  itemCategory: {
    id: 'bo_seller_customer_reviews_filters_item_category',
    defaultMessage: 'Item category',
  },
  market: {
    id: 'bo_seller_customer_reviews_filters_market',
    defaultMessage: 'Market',
  },
  orderNumber: {
    id: 'bo_seller_customer_reviews_filters_order_number',
    defaultMessage: 'Order number',
  },
  ratingMax: {
    id: 'bo_seller_customer_reviews_filters_maximum_rating',
    defaultMessage: 'Maximum rating',
  },
  ratingMin: {
    id: 'bo_seller_customer_reviews_filters_minimum_rating',
    defaultMessage: 'Minimum rating',
  },
  reset: {
    id: 'bo_seller_customer_reviews_filters_reset_filters',
    defaultMessage: 'Reset',
  },
  endDate: {
    id: 'bo_seller_customer_reviews_filters_end_date',
    defaultMessage: 'End date',
  },
  startDate: {
    id: 'bo_seller_customer_reviews_filters_start_date',
    defaultMessage: 'Start date',
  },
}
